import React, { useEffect, useState } from 'react'
import { Fetcher } from '../../Helpers/fetcher'
import { Notify } from '../../Helpers/notification';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Card, Spinner } from 'react-bootstrap';
import paginationFactory, { PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';

const formatDateTime = (cell) => {
    if (!cell) return "-";

    const date = new Date(cell.replace(" ", "T"));

    if (Number.isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
    });
};

const VoicePlanLogs = ({ app }) => {
    const userId = app.userId;
    const [logs, setLogs] = useState([])
    const [loading, setLoading] = useState(false);


    const getVoicePlanLogs = async () => {
        const apiPath = app.apiPath;
        try {
            setLoading(true)
            const res = await Fetcher.get(`${apiPath}/api/obd/get/user/voice/plan/logs/${userId}`)
            const data = Array.isArray(res) ? res : []
            setLogs(data)
        } catch (error) {
            Notify.notify("Error while getting the Logs")
            console.log("getVoicePlanLogs", error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getVoicePlanLogs()
    }, [])

    const columns = [
        {
            dataField: 'oldPlanId',
            text: 'Old Plan Id',
            sort: true,
            hidden: false
        },
        {
            dataField: 'newPlanId',
            text: 'New Plan Id',
            sort: true,
            hidden: false
        },
        {
            dataField: 'userId',
            text: 'User Id',
            sort: true,
            hidden: false
        },
        {
            dataField: 'username',
            text: 'User Name',
            sort: true,
            hidden: false
        },
        {
            dataField: 'requestDate',
            text: 'Request Date',
            sort: true,
            hidden: false,
            formatter: (cell, row) => {
                const date = formatDateTime(row.requestDate)
                return date ?? "-"
            }
        },
    ];

    const { SearchBar, ClearSearchButton } = Search;
    const defaultSorted = [{
        dataField: 'requestDate',
        order: 'desc'
    }];
    const paginationOption = {
        custom: true,
        totalSize: logs.length,
        sizePerPage: 10,
        sizePerPageList: [10, 25, 50, 100],
    };
    return (
        <Card>
            <Card.Header>Voice Plan Logs</Card.Header>
            <Card.Body>

                <div className="user-list-table-cont">
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    ) : (
                        <PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <ToolkitProvider
                                        keyField="id"
                                        data={logs}
                                        columns={columns}
                                        search
                                        bootstrap4
                                    >
                                        {
                                            props => (
                                                <div className="">
                                                    Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                    <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                    <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                    <hr />
                                                    <BootstrapTable
                                                        bordered={true}
                                                        defaultSorted={defaultSorted}
                                                        striped={true}
                                                        condensed
                                                        wrapperClasses="table-responsive"
                                                        classes="userCampaignList-table"
                                                        {...props.baseProps}
                                                        {...paginationTableProps}
                                                        noDataIndication={"No Logs to show"}
                                                    />
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            )
                                        }
                                    </ToolkitProvider>
                                )
                            }
                        </PaginationProvider>
                    )}
                </div>
            </Card.Body>
        </Card>
    )
}

export default VoicePlanLogs